import React, { useContext } from 'react'
import { Link } from 'react-router-dom'
import useCommunityIdOrSlug from '../../../hooks/useCommunityIdOrSlug'
import { IconGlyph } from '../../../icons/IconGlyph'
import { CurrentUserContext } from '../../../providers/CurrentUserContext'
import Routes from '../../../startup/routes'
import UserNav from './UserNav'

const PublicNav: React.FC = () => {
  const { currentUser } = useContext(CurrentUserContext)

  let communitySlug = useCommunityIdOrSlug()
  if (currentUser) {
    communitySlug = undefined
  }

  return (
    <nav className="public-nav">
      <ul>
        <li>
          <Link to={Routes.events(communitySlug)}>
            <IconGlyph name="calendar" color="red" />
            <span>Events</span>
          </Link>
        </li>
        <li>
          <Link to={Routes.places(communitySlug)}>
            <IconGlyph name="location" color="green" />
            <span>Places</span>
          </Link>
        </li>
        <li>
          <Link to={Routes.stories(communitySlug)}>
            <IconGlyph name="megaphone" color="blue" />
            <span>Stories</span>
          </Link>
        </li>
      </ul>
      <UserNav />
    </nav>
  )
}

export default PublicNav
